
(() => {
  if (!customElements.get("product-media-thumbs")) {
    class ProductMediaThumbs extends HTMLElement {
      constructor() {
        super();

        this.swiper = new Swiper(this, {
          direction: 'horizontal',
          slidesPerView: 5,
          spaceBetween: 11,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              direction: 'vertical'
            }
          }
        });
      }
    }

    customElements.define("product-media-thumbs", ProductMediaThumbs);
  }

  if (customElements.get("product-media-slideshow")) {
    return;
  }

  class ProductMediaSlideshow extends HTMLElement {
    constructor() {
      super();

      const thumbsElement = this.closest('.product__media-wrapper').querySelector('product-media-thumbs');

      this.swiper = new Swiper(this, {
        enabled: true,
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 8,
        thumbs: thumbsElement ? {
          swiper: thumbsElement.swiper
        } : false,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]')
        },
        ...(this.dataset.autoplay === "true" && {
          autoplay: {
            delay: Number(this.dataset.autoplayDelay),
            disableOnInteraction: false
          },
        }),
        breakpoints: {
          768: {
            slidesPerView: 1,
            enabled: this.dataset.layout === 'slider'
          }
        }
      });
    }

    setActive(id) {
      const slideElement = this.swiper.slides.find((s) => s.id === id);

      if (!slideElement) {
        return;
      }

      const slideIndex = this.swiper.slides.indexOf(slideElement);

      this.swiper.slideTo(slideIndex)

      if (window.innerWidth > 767 && slideElement && this.dataset.layout !== 'slider') {
        slideElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  customElements.define("product-media-slideshow", ProductMediaSlideshow);
})();
